import React from 'react';
import { Platform, Text } from 'react-native';

// Web stub for `react-native-vector-icons/Ionicons`. The real font isn't loaded
// on web, so we draw the handful of Ionicon names our components actually use
// as inline SVG (same approach as components/Icon.tsx) and fall back to a
// bullet for anything unmapped.
const PATHS: Record<string, string> = {
  'search':            '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>',
  'search-outline':    '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>',
  'close':             '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
  'close-outline':     '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>',
  'arrow-forward':     '<line x1="5" y1="12" x2="19" y2="12"/><polyline points="13 5 20 12 13 19"/>',
  'arrow-forward-outline': '<line x1="5" y1="12" x2="19" y2="12"/><polyline points="13 5 20 12 13 19"/>',
};

const Icon = ({ name, size = 16, color = '#666' }: { name?: string; size?: number; color?: string }) => {
  const paths = name ? PATHS[name] : undefined;
  if (Platform.OS === 'web' && paths) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0, display: 'block' }}
        dangerouslySetInnerHTML={{ __html: paths }}
      /> as any
    );
  }
  return <Text style={{ fontSize: size, color }}>•</Text>;
};

export default Icon;
